import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { DatePicker, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification.js";

import Loading from "../loader/loader.js";
import { Modal } from "react-bootstrap";
import NkHeader from "../../common/nkheader.js";
import NkTable from "../users/nktable.js";
import RechargeBenificiariesFilterBy from "./modals/recharge-beneficiaries-filter-by.js";
import { deleteMobileRecharge } from "../../service/profile-ras-service.js";
import { getAllRechargeBeneficiaryList } from "../../service/recharge-beneficiary-service.js";
import moment from "moment";
import { useHistory } from "react-router-dom";

function DeleteConformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to delete ?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          color="primary"
          onClick={() => props.handleDeleteUser(props.beneficiaryid)}
          disabled={props.buttonloading}
        >
          {props.buttonloading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const RechargeBeneficiaries = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    name: null,
    sender: null,
    beneficiary: null,
    receiver: null,
    fromDate: null,
    toDate: null,
    status: "",
    country: "",
    type: "",
    isFilter: true,
    typeLength: "",
    countryLength: "",
    applicationId: 1,
    // statusLength: "",
  };
  const [filterForm, setfilterForm] = useState(request);
  const [rechargebeneficiary, setRechargeBeneficiary] = useState([]);
  const [rechargebeneficiaryExcel, setRechargeBeneficiaryExcel] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchBy, setSearchBy] = useState("receiver");
  const [searchByValue, setSearchByValue] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [sizeShow, setSizeShow] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [beneficiaryid, setBeneficiaryid] = useState();
  const [buttonloading, setButtonloading] = useState(false);
  const buttonRef = useRef(null);
  const csvLink = useRef();
  const [type, setType] = useState([]);
  const [country, setCountry] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [filterLength, setFilterLength] = useState({
    typeLength: 0,
    countryLength: 0,
  });
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState();
  let searchByValuePlaceholder = "";
  if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "receiver") {
    searchByValuePlaceholder = "eg.971507878961";
  } else {
    searchByValuePlaceholder = "Amit Pandit";
  }
  const columnsCsv = [
    { key: "registrationDate", label: "Date" },
    { key: "fullName", label: "Full Name" },
    { key: "phoneNumber", label: "Sender" },
    { key: "beneficiary", label: "Beneficiary" },
    { key: "accountNumber", label: "Receiver" },
    { key: "country", label: "Country" },
  ];

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getAllRechargeBeneficiarytablelist(filterForm);
      // getAllRechargeBeneficiarytablelistExcel(filterForm);
    }
  }, [filterForm]);

  const getAllRechargeBeneficiarytablelist = (request) => {
    request["type"] = request.type.length == 0 ? "" : request.type;
    request["country"] = request.country.length == 0 ? "" : request.country;
    request.size = sizeShow || 10;
    setDataLoading(true);
    getAllRechargeBeneficiaryList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.beneficiaries.length > 0) {
          setRechargeBeneficiary(res.data.beneficiaries || []);
          setPagination({
            ...pagination,
            pageSize: sizeShow || 10,
            total: res.data.totalCount,
            current: request.page,
          });
        } else {
          setRechargeBeneficiary([]);
        }
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        setRechargeBeneficiary([]);
      });
  };

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    request["type"] = request.type.length == 0 ? "" : request.type;
    request["country"] = request.country.length == 0 ? "" : request.country;
    request.size = null;
    // setDataLoading(true);
    getAllRechargeBeneficiaryList(request)
      .then((res) => {
        // setDataLoading(false);
        if (res && res.data && res.data.beneficiaries.length > 0) {
          let data = res.data.beneficiaries.map((element) => {
            element.registrationDate = moment(element.registrationDate).format(
              "DD-MM-YYYY"
            );
            return element;
          });
          setRechargeBeneficiaryExcel(data || []);
          buttonRef.current.click();
        }
      })
      .catch((err) => {
        // setDataLoading(false);
        setRechargeBeneficiaryExcel([]);
      });
  };

  const handleFilter = () => {
    let request = {};
    if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiary: searchByValue.trim(),
        receiver: null,
      };
    } else if (searchBy === "receiver") {
      request = {
        ...filterForm,
        receiver: searchByValue.trim(),
        beneficiary: null,
      };
    }

    if (filterForm.type && filterForm.type.length > 0) {
      let a = "";
      filterForm.type &&
        filterForm.type.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.type.length ? "," : "");
        });
      request.type = a || "";
      request.typeLength = filterForm.type.length;
    } else {
      request.type = filterForm.type || "";
      request.typeLength = "";
    }

    if (filterForm.country && filterForm.country.length > 0) {
      let a = "";
      filterForm.country &&
        filterForm.country.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.country.length ? "," : "");
        });
      request.country = a || "";
      request.countryLength = filterForm.country.length;
    } else {
      request.country = filterForm.country || "";
      request.countryLength = "";
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setfilterForm(request);
  };

  const handleChangesPath = (data) => {
    let states = { ...data };
    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.userId },
    });
  };

  const columns = [
    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            <img
              alt="..."
              style={{ width: "40px", height: "20px", cursor: "pointer" }}
              src={require("assets/img/icons/common/user.svg")}
              onClick={() => {
                if (row && row.id) {
                  handleChangesPath(row);
                }
              }}
            />
            <i
              className="fas fa-trash-alt"
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (row && row.id) {
                  setBeneficiaryid(row.id);
                  setDeleteModal(true);
                }
              }}
            />
          </>
        );
      },
    },
    {
      dataField: "registrationDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "fullName",
      text: "Full Name",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "phoneNumber",
      text: "Sender",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "160px", textAlign: "center" },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "accountNumber",
      text: "Receiver",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "countryName",
      text: "Country",
      sort: false,
      style: { minWidth: "140px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      style: { minWidth: "140px", textAlign: "left" },
    },
    // {
    //   dataField: "PartnerReference",
    //   text: "Ding Transaction Ref Number",
    //   sort: false,
    //   style: { minWidth: "140px", textAlign: "left" },
    // },
  ];

  const clearFilter = () => {
    setType();
    setCountry();

    setfilterForm({
      ...filterForm,
      type: "",
      country: "",
      typeLength: "",
      countryLength: "",
    });
  };

  const resetFilter = () => {
    setType();
    setCountry();
    setSearchByValue("");
    setSearchBy("receiver");
    setFromDate("");
    setfilterForm({
      ...request,
      type: "",
      country: "",
      typeLength: "",
      countryLength: "",
    });
    // setRechargeBeneficiary([]);
    // setRechargeBeneficiaryExcel([]);
    setToDate("");
    setNoOfFiltersSelected(0);
    setFilterLength({ typeLength: 0, countryLength: 0 });
    // clearFilter();
  };

  const handleDeleteUser = (id) => {
    setButtonloading(true);
    deleteMobileRecharge(id)
      .then((res) => {
        setDeleteModal(false);
        setButtonloading(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Delete Successfully"
        );
        getAllRechargeBeneficiarytablelist(filterForm, id);
      })
      .catch((err) => {
        setDeleteModal(false);
        setButtonloading(false);
        //openNotificationWithIcon(notificationStrings.error, err);
        // message.error("Something went wrong");
      });
  };

  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Container fluid>
        <NkHeader title="Recharge Beneficiaries" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search by
                  </label>
                  <Input
                    id="exampleFormControlSelect1"
                    type="select"
                    value={searchBy}
                    style={{ height: "27px" }}
                    onChange={(e) => setSearchBy(e.target.value)}
                  >
                    <option value="receiver">Receiver</option>
                    <option value="beneficiary">Beneficiary</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search for
                  </label>
                  <Input
                    id="example3cols2Input"
                    placeholder={searchByValuePlaceholder}
                    onKeyPress={(e) => e.charCode === 13 && handleFilter(true)}
                    type="text"
                    style={{ height: "27px" }}
                    onChange={(e) =>
                      setSearchByValue(
                        e.target && e.target.value && e.target.value
                      )
                    }
                    value={searchByValue}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    From
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setFromDate(moment(dateString, dateFormat));
                      } else {
                        setFromDate(null);
                      }
                    }}
                    value={fromDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>

              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    To
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setToDate(moment(dateString, dateFormat));
                      } else {
                        setToDate(null);
                      }
                    }}
                    value={toDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>
              <div
                lg="1"
                className="form-input-padding"
                style={{ marginTop: "2px" }}
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Filter by
                  </Label>

                  <div>
                    <Button
                      style={{ width: "100%", height: "26px" }}
                      color="primary"
                      type="button"
                      id="example3cols2Input"
                      className="filter-button-beneficiery"
                      onClick={() => setShowFilterModal(true)}
                    >
                      <div>
                        <i className="fas fa-filter"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
                <span style={{ fontSize: 8 }}>
                  {noOfFiltersSelected > 0 ? (
                    <>
                      <h6 style={{ display: "flex", alignItems: "center" }}>
                        selected(
                        {noOfFiltersSelected}){" "}
                        <i
                          className="fas fa-window-close"
                          style={{ cursor: "pointer", paddingLeft: "5px" }}
                          onClick={() => resetFilter()}
                        />
                      </h6>
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              </div>

              <Col lg="1" style={{ marginTop: "9px", padding: "0px 9px" }}>
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      id="example3cols2Input"
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      className="filter-button"
                      onClick={() => handleFilter(true)}
                    >
                      <div>
                        <i className="fas fa-search" />
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "9px", padding: "0px 6px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      color="light"
                      type="button"
                      style={{ width: "100%", height: "26px" }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => resetFilter()}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        <i className="fas fa-redo-alt 2px"></i> Reset
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <div className="col card-parent">
            <Card style={{ padding: "1.25rem 1.5rem" }}>
              {dataLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Loading />
                </div>
              ) : (
                <>
                  <NkTable
                    dataexcal
                    filename={"recharge-beneficiary"}
                    data={rechargebeneficiary}
                    dataEXCEL={rechargebeneficiaryExcel}
                    buttonRef={buttonRef}
                    csvLink={csvLink}
                    filterdata={filterForm}
                    type="rechargebeneficiry"
                    onExcelClciked={() => onExcelClciked(filterForm)}
                    columns={columns}
                    columnsCsv={columnsCsv}
                    pagination={pagination}
                    onPagechange={(page) => {
                      setfilterForm({ ...filterForm, page: page });
                    }}
                    showSizeChanged={(pageSize) => {
                      setSizeShow(pageSize);
                      // let request = { ...filterForm};
                      // console.log({ request });
                      setfilterForm({ ...filterForm });
                      // getAllRechargeBeneficiarytablelist(request);
                    }}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <RechargeBenificiariesFilterBy
        show={showFilterModal}
        type={type}
        setType={setType}
        country={country}
        setCountry={setCountry}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={(saveResponse) => {
          console.log(saveResponse);
          setfilterForm({ ...filterForm, ...saveResponse, isFilter: false });
          setShowFilterModal(false);
        }}
        type1={filterForm.type}
        country1={filterForm.country}
        setNoOfFiltersSelected={setNoOfFiltersSelected}
        setFilterLength={setFilterLength}
        filterLength={filterLength}
      />
      <DeleteConformation
        buttonloading={buttonloading}
        show={deleteModal}
        handleDeleteUser={handleDeleteUser}
        beneficiaryid={beneficiaryid}
        onHide={() => setDeleteModal(false)}
      />
    </>
  );
};

export default RechargeBeneficiaries;
